import { useEffect } from 'react'
import { C, SUPPORT_EMAIL, MAILING_ADDRESS } from '../components/shared'

/*
 * /refund (Launch fixes 1, the PM's decision 3, 2026-10-19): the terms' payment lines (src/legal/terms.md section 7)
 * in plain words. It promises nothing the terms do not; change the terms first, then this page.
 */

const POINTS = [
  ['Cancel any time', 'Cancel from the billing page in the app (Manage billing). Nothing else is needed.'],
  ['Your plan runs to the end of the period', 'After you cancel, your plan stays active until the end of the period you paid for, then it ends. Your reports stay readable.'],
  ['No refund for part of a month', 'We do not refund part of a month.'],
  ['The trial is free', 'The 14-day trial is free and needs no card. Publishing a change needs a paid plan.'],
  ['Questions', `Write to ${SUPPORT_EMAIL}.`],
] as const

export default function RefundPage() {
  useEffect(() => {
    document.title = 'Refunds and cancellation | SerpDesk'
    document.querySelector('meta[name="description"]')?.setAttribute('content', 'Cancel any time; the plan runs to the end of the period you paid for; no refund for part of a month; the trial is free and needs no card.')
  }, [])
  return (
    <>
      <section style={{ background: C.hero, color: '#fff', paddingTop: 125, paddingBottom: 56 }}>
        <div style={{ maxWidth: 760, margin: '0 auto', padding: '0 24px' }}>
          <h1 style={{ fontFamily: 'var(--display)', fontSize: 'clamp(30px, 5vw, 44px)', fontWeight: 700, margin: 0 }}>Refunds and cancellation</h1>
        </div>
      </section>
      <section style={{ background: C.surface, padding: '40px 0 80px' }}>
        <article style={{ maxWidth: 760, margin: '0 auto', padding: '0 24px' }}>
          {POINTS.map(([h, t]) => (
            <div key={h} style={{ marginBottom: 26 }}>
              <h2 style={{ fontFamily: 'var(--display)', fontSize: 20, fontWeight: 700, color: C.ink, margin: '0 0 8px' }}>{h}</h2>
              <p style={{ fontSize: 15, color: C.body, lineHeight: 1.75, margin: 0 }}>
                {h === 'Questions'
                  ? <>Write to <a href={`mailto:${SUPPORT_EMAIL}`} style={{ color: C.purple }}>{SUPPORT_EMAIL}</a>.</>
                  : t}
              </p>
            </div>
          ))}
          <p style={{ fontSize: 14, color: C.muted, lineHeight: 1.7, marginTop: 36 }}>
            The full payment terms are in section 7 of the <a href="/terms" style={{ color: C.purple }}>terms of service</a>. See also <a href="/pricing" style={{ color: C.purple }}>pricing</a>.
          </p>
          <address style={{ fontStyle: 'normal', fontSize: 13.5, color: C.muted, lineHeight: 1.7, marginTop: 12 }}>{MAILING_ADDRESS}</address>
        </article>
      </section>
    </>
  )
}
